

const searchData = [
    //! üst menü
    {
        id:"1.1",
        mainMenu: "Üst Menü",
        altMenu: "Yük Ekle",
        keyWords: ["yük ekle", "yük kaydet", "yeni yük ekleme", "yeni yük kaydetme"],
        desc: "Yeni yük kaydetme, yeni yük ekleme işlemleri yapılmaktadır.",
        path: "/yuk-ekle"
    },
    {
        id:"1.2",
        mainMenu: "Üst Menü",
        altMenu: "Yükler Listesi",
        keyWords: ["yükler", "yükler listesi", "yüklerim", "tüm yükler"],
        desc: "Tüm yükler listesi, kaydedilen yüklerim listelenmektedir.",
        path: "/yukler-listesi"
    },
    {
        id:"1.3",
        mainMenu: "Üst Menü",
        altMenu: "Atananlar",
        keyWords: ["atananlar", "atanan sevkiyatlar", "atanmış yükler", "sürücüye atanan yükler"],
        desc: "Sürücü ve araç ataması yapılmış sevkiyatlar listelenmektedir.",
        path: "/atananlar"
    },
    {
        id:"1.5",
        mainMenu: "Üst Menü",
        altMenu: "Yüklemede",
        keyWords: ["yüklemede", "yüklenen", "yükleniyor", "yükleme noktasında"],
        desc: "Sürücü onayı sonrasında; yükleme aşamasında, yükleme noktasında, yüklemede, yükleniyor olan yükler listelenmektedir.",
        path: "/yuklemede"
    },
    {
        id:"1.6",
        mainMenu: "Üst Menü",
        altMenu: "Seferde",
        keyWords: ["seferde"],
        desc: "Seferde, sevkiyatta, sevkiyat aşamasında olan yükler listelenmektedir.",
        path: "/seferde"
    },
    {
        id:"1.7",
        mainMenu: "Üst Menü",
        altMenu: "Boşaltmada",
        keyWords: ["boşaltmada"],
        desc: "Teslim aşamasında ve boşaltmada olan yükler listelenmektedir.",
        path: "/bosaltmada"
    },
    {
        id:"1.8",
        mainMenu: "Üst Menü",
        altMenu: "Tamamlanan Seferler",
        keyWords: ["tamamlanan Seferler"],
        desc: "Tamamlanan seferler, tamamlanan sevkiyatlar listelenmektedir.",
        path: "/tamamlanan-seferler"
    },

    //! yük işlemleri
    {
        id:"2.1",
        mainMenu: "Yük İşlemleri",
        altMenu: "İş Listesi",
        keyWords: ["iş listesi"],
        desc: "İş listesi, iş listem, işlerim, yüklerim, sıra, sıradaki araçlar, sıradaki sürücüler listelenmektedir. Sürücü yük eşleştirmesi, araç yük eşleştirmesi yapılabilmektedir.",
        path: "/yuk-islemleri/is-listesi"
    },
    {
        id:"2.2",
        mainMenu: "Yük İşlemleri",
        altMenu: "Sürücüler ve Araçlar",
        keyWords: ["devamlı araçlarım", "devamlı araçlar", "çalıştığım araçlar","misafir araçlarım"],
        desc: "Sürücüler, araçlar, devamlı araçlarım, devamlı sürücülerim, çalıştığım sürücüler, çalıştığım araçlar, misafir sürücüler, misafir araçlar listelenmektedir.  Yeni sürücü ekleme, yeni araç ekleme yapılabilmektedir.",
        path: "/yuk-islemleri/devamli-araclarim"
    },
    {
        id:"2.3",
        mainMenu: "Yük İşlemleri",
        altMenu: "Plaka Sorgulama",
        keyWords: ["yük ekle", "yük kaydet", "yeni yük ekleme", "yeni yük kaydetme"],
        desc: "Plaka sorgulama, araç yetki belgesi sorgulama, araç muayene sorgulama yapılabilmektedir.",
        path: "/yuk-islemleri/plaka-sorgulama"
    },
    {
        id:"2.4",
        mainMenu: "Yük İşlemleri",
        altMenu: "Adres Yönetimi",
        keyWords: ["yetki belgesi", "yetki belgesi sorgula", "araç yetki belgesi", "araç yetki belgesi sorgula", "src", "src sorgula", "src belgesi sorgula", "sürücü yetki belgesi sorgula"],
        desc: "Ön tanımlı yük, ve adres kayırları listelenmektedir. Ekleme ve silme işlemi yapılabilmektedir.",
        path: "/yuk-islemleri/adres-yonetimi"
    },

    //! üyeler ve araçlar
    {
        id:"3.1",
        mainMenu: "Üyeler ve Araçlar",
        altMenu: "Üyeler",
        keyWords: ["üyeler"],
        desc: "üyeler",
        path: "/uyeler-ve-araclar/uyeler"
    },
    {
        id:"3.2",
        mainMenu: "Üyeler ve Araçlar",
        altMenu: "Araçlar",
        keyWords: ["araçlar"],
        desc: "araçlar",
        path: "/uyeler-ve-araclar/araclar"
    },
    {
        id:"3.3",
        mainMenu: "Üyeler ve Araçlar",
        altMenu: "Yetki Belgesi Sorgulama",
        keyWords: ["yetki belgesi sorgulama"],
        desc: "yetki belgesi sorgulama",
        path: "/uyeler-ve-araclar/plaka-sorgulama"
    },    


    //! sürücülerim ve araçlarım-firmalarım
    {
        id:"4.1",
        mainMenu: "Sürücülerim ve Araçlarım-Firmalarım",
        altMenu: "Sürücüler ve Araçlar",
        keyWords: [""],
        desc: "Sürücüler, araçlar, devamlı araçlarım, devamlı sürücülerim, çalıştığım sürücüler, çalıştığım araçlar, misafir sürücüler, misafir araçlar listelenmektedir. Yeni kayıt eklenebilmektedir.",
        path: ""
    },
    {
        id:"4.2",
        mainMenu: "Sürücülerim ve Araçlarım-Firmalarım",
        altMenu: "Firmalar",
        keyWords: [""],
        desc: "Firmalar, müşteriler, fabrikalar, yükverenler, yük verenler kayıtları listelenmektedir. Yeni kayıt eklenebilmektedir.",
        path: ""
    },


    //! hesaplamalar
    {
        id:"5.1",
        mainMenu: "Hesaplamalar",
        altMenu: "Nakliye Fiyatı Hesaplama",
        keyWords: [""],
        desc: "Başlangıç ve bitiş il-ilçe bilgileri ile Nakliye fiyat hesaplaması yapabilirsiniz. Hesaplamada yaklaşık maliyetler kullanılmıştır. Bilgi amacıyla hazırlanmıştır.",
        path: ""
    },
    {
        id:"5.2",
        mainMenu: "Hesaplamalar",
        altMenu: "Km Hesaplama",
        keyWords: [""],
        desc: "Nereden nereye mesafe hesaplama, güzergah hesaplama, km hesaplama yapılabilme ve haritada gösterilmektedir.",
        path: ""
    },
    {
        id:"5.3",
        mainMenu: "Hesaplamalar",
        altMenu: "KDV ve Tevkifat Hesaplama",
        keyWords: [""],
        desc: "KDV hesaplama, Tevkifat hesaplama, tevkifatlı fatura hesaplaması yapılabilmektedir.",
        path: ""
    },
    {
        id:"5.4",
        mainMenu: "Hesaplamalar",
        altMenu: "Sera Gazı Emisyonu Hesaplama",
        keyWords: [""],
        desc: "Sera gazı emisyonu, karbon emisyonu, hava kirliliği hesaplaması yapılabilmektedir. Emisyon karşılığı ağaç sayısıda gösterilmektedir.",
        path: ""
    },



    //! E-Arşiv Fatura
    {
        id:"6.1",
        mainMenu: "E-Arşiv Fatura",
        altMenu: "Kestiğim e-Arşiv Faturalarım",
        keyWords: [""],
        desc: "",
        path: ""
    },
    {
        id:"6.2",
        mainMenu: "E-Arşiv Fatura",
        altMenu: "Bana Kesilen e-Arşiv Faturalar",
        keyWords: [""],
        desc: "",
        path: ""
    },
    {
        id:"6.3",
        mainMenu: "E-Arşiv Fatura",
        altMenu: "e-Arşiv Fatura Kes",
        keyWords: [""],
        desc: "",
        path: ""
    },
    {
        id:"6.4",
        mainMenu: "E-Arşiv Fatura",
        altMenu: "GİB Hesabı",
        keyWords: [""],
        desc: "",
        path: ""
    },


    //! Uygun Sigorta Bul
    {
        id:"7.1",
        mainMenu: "Uygun Sigorta Bul",
        altMenu: "Uygun Sigorta Bul",
        keyWords: [""],
        desc: "Uygun sigorta, trafik sigortası, kasko, dask, yangın sigortası, konut sigortası, sağlık sigortası vb. tüm sigorta türlerinde teklif alınabilmektedir.",
        path: ""
    },


    //! İlanlar
    {
        id:"8.1",
        mainMenu: "İlanlar",
        altMenu: "Kiralık Araç Arayan Firmalar",
        keyWords: [""],
        desc: "Kiralık araç arayan firmalar, araç kiralamak isteyenler listelenmektedir.",
        path: ""
    },
    {
        id:"8.2",
        mainMenu: "İlanlar",
        altMenu: "Kiralık Araçlar",
        keyWords: [""],
        desc: "Kiralık araçlar, aracını kiraya vermek isteyenler listelenmektedir.",
        path: ""
    },
    {
        id:"8.3",
        mainMenu: "İlanlar",
        altMenu: "İş Arayan Sürücüler",
        keyWords: [""],
        desc: "İş arayan sürücüler listelenmektedir.",
        path: ""
    },
    {
        id:"8.4",
        mainMenu: "İlanlar",
        altMenu: "Sürücü Arayanlar",
        keyWords: [""],
        desc: "Sürücü arayan firmalar ve araç sahipleri listelenmektedir.",
        path: ""
    },
    {
        id:"8.5",
        mainMenu: "İlanlar",
        altMenu: "Satılık Araçlar",
        keyWords: [""],
        desc: "Satılık araçlar listelenmektedir. Sadece ticari araçlar kaydedilecek ve listelenecektir.",
        path: ""
    },


    //! Sarı Sayfalar
    {
        id:"9.1",
        mainMenu: "Sarı Sayfalar",
        altMenu: "Sarı Sayfalar",
        keyWords: [""],
        desc: "Nakliyeci Rehberi, Güvenli park Yerleri, Restoranlar/Lokantalar, Lastik Tamircileri, Tamirciler, Oto elektrikçiler, Oto Kurtarıcılar, Lastik Satışı, Akü Satışı, Yedek Parça Aksesuar Satışı vb. hizmetler için arama yapılabilecektir.",
        path: ""
    },


    //! Kasa Defteri
    {
        id:"10.1",
        mainMenu: "Kasa Defteri",
        altMenu: "Kasa Defteri",
        keyWords: [""],
        desc: "Kasa defteri, muhasebe defteri, muhasebe kaydı, gelir kaydetme, gider kaydetme vb. işlemler yapılabilmektedir.",
        path: ""
    },


    //! Raporlar
    {
        id:"11.1",
        mainMenu: "Raporlar",
        altMenu: "Raporlar",
        keyWords: [""],
        desc: "Buradan raporları görüntüleyebilirsiniz.",
        path: ""
    },

    //! Profilim
    {
        id:"12.1",
        mainMenu: "Profilim",
        altMenu: "Firma Bilgileri",
        keyWords: [""],
        desc: "Firma bilgileri, bilgilerim kaydedilmekte ve düzenlenebilmektedir.",
        path: ""
    },
    {
        id:"12.2",
        mainMenu: "Profilim",
        altMenu: "Firma Belgeleri",
        keyWords: [""],
        desc: "Firma belgeleri, belgelerim kaydedilmekte ve düzenlenebilmektedir.",
        path: ""
    },
    {
        id:"12.3",
        mainMenu: "Profilim",
        altMenu: "Kullanıcılar",
        keyWords: [""],
        desc: "Kullanıcı işlemleri yapılabilmektedir. Kullanıcılarda düzenleme ve yeni kullanıcı eklemesi yapılabilmektedir.",
        path: ""
    },
    {
        id:"12.4",
        mainMenu: "Profilim",
        altMenu: "Özvarlık Araçlarım",
        keyWords: [""],
        desc: "Firma araçları, araçlarım kaydedilmekte ve düzenlenebilmektedir.",
        path: ""
    },
    {
        id:"12.5",
        mainMenu: "Profilim",
        altMenu: "Sürücülerim",
        keyWords: [""],
        desc: "Firma sürücüleri, sürücülerim kaydedilmekte ve düzenlenebilmektedir.",
        path: ""
    },


    //! Engellenen Araçlar
    {
        id:"13.1",
        mainMenu: "Engellenen Sürücüler",
        altMenu: "Engellenen Sürücüler",
        keyWords: [""],
        desc: "Engellelen sürücüler, engellediğim sürücüler, engellenen sürücüler, engellediğim sürücüler görüntülebilmektedir. Listede düzenleme, ekleme ve çıkarma yapılabilmektedir. Engellenen sürücüler o firmaya ait yükleri göremez ve teklif veremezler.",
        path: ""
    },


    //! Destek - Geri Bildirim
    {
        id:"14.1",
        mainMenu: "Destek - Geri Bildirim",
        altMenu: "Destek - Geri Bildirim",
        keyWords: [""],
        desc: "Yardım, destek, geri bildirim, şikayet işlemleri yapılabilmektedir. Talep sonrası sonuç geri dönüşleri de burada görülebilmektedir.",
        path: ""
    },
    

    //! Hakkında
    {
        id:"15.1",
        mainMenu: "Hakkında",
        altMenu: "Kamyoon Kullanım kuralları",
        keyWords: [""],
        desc: "Kamyoon kullanım kuralları görüntülebilmektedir.",
        path: ""
    },
    {
        id:"15.2",
        mainMenu: "Hakkında",
        altMenu: "Kamyoon Kullanım Kılavızu",
        keyWords: [""],
        desc: "Kamyoon kullanım kılavuzu görüntülebilmektedir.",
        path: ""
    },

    {
        id:"15.3",
        mainMenu: "Hakkında",
        altMenu: "Sıkça Sorulan Sorular",
        keyWords: [""],
        desc: "SSS (Sıkça Sorulan Sorular) ve cevapları görüntülenebilmektedir. Buradan soru sorulabilmekte ve destek talebi oluşturulabilmektedir.",
        path: ""
    },


]

export default searchData
